import { connect } from 'react-redux'
import editAddressSelector from './editAddressSelector'
import requestChangeIncomingMail from '../../../../../sagas/requestChangeIncomingMail'
import EditAddress from './EditAddress'

export default connect(
  editAddressSelector,
  {
    requestChangeIncomingMail
  }
)(EditAddress)
